import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { MultiSelectOption } from '../multi-select/multi-select.component';
import { ProgramType } from './program-type.enum';

@Component({
  selector: 'osn-cxb-program-type-selector',
  templateUrl: './program-type-selector.component.html',
  styleUrls: ['./program-type-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProgramTypeSelectorComponent),
      multi: true,
    },
  ],
})
export class ProgramTypeSelectorComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input('data-testid') public testId?: string;

  private readonly destroyed$ = new Subject<void>();
  public programTypeOptions: MultiSelectOption[] = [
    { id: ProgramType.Movie, label: 'Movies' },
    { id: ProgramType.Series, label: 'Series' },
  ];

  public programTypeControl = new UntypedFormControl([]);

  public disabled: boolean;

  public propagateChange: Function = () => {};
  public propagateTouch: Function = () => {};

  public ngOnInit(): void {
    this.programTypeControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter(() => this.programTypeControl.dirty)
      )
      .subscribe((contentTypes) => this.propagateChange(contentTypes));
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public writeValue(value: ProgramType[]): void {
    this.programTypeControl.setValue(value);
  }

  public registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.programTypeControl.disable();
    } else {
      this.programTypeControl.enable();
    }
  }
}
